import { Container, Row, Col } from 'react-bootstrap';
import Footer from './components/Footer';

export default function Social() {

  return (
    <>
      <section id="hero" className="hero hero-background  position-relative">
        <Container >
          <Row className="align-items-center">
              <Col md={8} lg={6} className=''>
                <h1 className="display-3 fw-bold text-white">Social Events</h1>
              </Col>
            </Row>
        </Container>
      </section>
      <Container className='py-5'>
        <Row>
          <Col lg={{ span: 8, offset: 2 }} className='pb-5'>
            <h2 className='h1 mb-4 purple-h'>Welcome Reception</h2>
            <p>The welcome reception will be held at the conference venue, <highlight>on the terrace of the Kompas Hotel, offering an amazing view of Lake Bled and the castle.</highlight> This relaxed gathering will offer an opportunity for participants to connect in a warm and informal atmosphere, setting the tone for the days ahead.</p>
            <h2 className='h1 mb-4 purple-h mt-5'>Visit to Bled Island and Church</h2>
            <p>Participants will have the chance to take <highlight>a scenic boat trip to Bled Island</highlight>, home to the picturesque Church of the Assumption. This iconic landmark, with its 99 stone steps and beautiful frescoes, provides a perfect blend of natural beauty and cultural heritage. A guided tour will give insights into the island’s rich history and significance, making this excursion a memorable experience.</p>
            <h2 className='h1 mb-4 purple-h mt-5'>Gala Dinner & Visit to Bled Castle</h2>
            <p>The gala dinner will be hosted at the castle restaurant, perched atop the cliffs of Bled Castle. Guests will enjoy a <highlight>refined dining experience featuring local cuisine, while taking in panoramic views of the lake and the surrounding Julian Alps.</highlight> Before the dinner, attendees will have the opportunity to explore Bled Castle itself, Slovenia’s oldest castle, admiring its medieval architecture, museum exhibits, and the breathtaking vistas from its ancient ramparts. This elegant evening will combine exquisite food and captivating scenery, offering the perfect setting to celebrate the conference’s achievements and build meaningful connections. </p>
          </Col>
        </Row>
      </Container>
      <Footer />
    </>
  );
}
 